appSocial.service('SocialPortfolioService', ['SocialAPIService', 'SocialUserService', 'SocialConstants', 'Trader',
    function (SocialAPIService, SocialUserService, SocialConstants, Trader) {

        class SocialPortfolioService {
            constructor() {
                /**
                 * @type {Trader[]}
                 */
                this.leaders = [];
                /**
                 * @type {SocialAPIService}
                 */
                this.api = SocialAPIService;
                /**
                 * @type {SocialUserService}
                 */
                this.userService = SocialUserService;
            }

            init() {
                this.leaders = [];
                const user = this.userService.get();
                if (user.id) {
                    return this.api.request.getLeaders({page: 0, limit: 100})
                        .then((response) => response.leaders.map(item => {
                            const rawLeader = {
                                follow_id: item.follow_id,
                                deposit: item.deposit,
                                stop_loss: item.stop_loss,
                                balance: item.balance,
                                state: item.state,
                                follow_start: item.follow_start,
                                stopped: item.stopped,
                                pnl: item.pnl,
                            };
                            const trader = new Trader(item.trader);
                            trader.initLeader(rawLeader);
                            return trader;
                        }))
                        .then((leaders) => {
                            this.leaders = leaders;
                            //this.onChange$.next();
                        });
                }
                return Promise.resolve();
            }

            get sumFollowBalance() {
                return this.leaders.reduce((acc, cur) => acc + cur.followBalance, 0);
            }

            isFollowed(traderId) {
                return !!_.find(this.leaders, {id: traderId});
            }

            reload() {
                return this.init();
            }

            /**
             *
             * @param {string} traderId
             * @return {Trader}
             */
            get(traderId) {
                return _.find(this.leaders, {id: traderId});
            }

            getAll() {
                return this.leaders;
            }

            clear() {
                this.leaders = [];
                //this.onChange$.next();
            }

            getExposure() {
                return this.api.request.getExposure()
                    .then((response) => {
                        const markets = SocialConstants.markets.map(market => {
                            const tradesByMarket = find(response.data, {market: market.id});
                            return {
                                name: market.id.toLowerCase(),
                                percentage: tradesByMarket ? tradesByMarket.percentage : 0,
                            };
                        });
                        return _.orderBy(markets, ['percentage'], 'desc');
                    });
            }

            /**
             * Set/unset leader properties on trader if it exists in portfolio
             * @param {Trader} trader
             */
            initLeader(trader) {
                const leader = this.get(trader.id);
                if (leader) {
                    trader.isFollowed = true;
                    trader.followId = leader.followId;
                    trader.followDeposit = leader.followDeposit;
                    trader.followStopLoss = leader.followStopLoss;
                    trader.followBalance = leader.followBalance;
                    trader.followState = leader.followState;
                    trader.followPnl = leader.followPnl;
                    trader.followPnlPercents = leader.followPnlPercents;
                } else {
                    trader.isFollowed = false;
                    trader.followId = null;
                    trader.followDeposit = null;
                    trader.followStopLoss = null;
                    trader.followBalance = null;
                    trader.followState = null;
                    trader.followPnl = null;
                    trader.followPnlPercents = null;
                }
            }

            /**
             * @param {Trader[]} traders
             * @return {Trader[]}
             */
            reInitLeaders(traders) {
                traders.forEach((trader) => this.initLeader(trader));
                return traders;
            }
        }

        return new SocialPortfolioService();
    }]);
